import DescriptionApis from '@/services/apis/description'

const description = new DescriptionApis()
export default {
  data() {
    return {
      text: '',
    }
  },
  mounted() {
    description.get({ name: 'agreement-register' }).then(res => {
      this.text = res.data.results.value
    })
  },
}
